
import React, { useEffect, useRef ,useState} from 'react';
import videojs from 'video.js';
import { DatePicker } from 'antd';
import 'video.js/dist/video-js.css';
import { Button, Modal } from 'antd';
import Main from "../components/layout/Main";
import back from '../assets/images/back.svg';
import Header from "../components/layout/Header";
import { Space, Slider, Input, Tag, Dropdown } from 'antd';
import { get, post } from "../Libraries/Ajax/HttpService";
import {
    ReconciliationOutlined, FieldTimeOutlined, SwapOutlined,
    DashboardOutlined, ArrowLeftOutlined, ArrowDownOutlined, DownOutlined, EditOutlined, CloseOutlined, CheckOutlined, DeleteOutlined, BugOutlined
} from '@ant-design/icons';
import {

    XAxis,
    YAxis,
    CartesianGrid,
    LineChart,
    Legend,
    Tooltip,
    Line,
    Label,
    Bar,
    BarChart,Area,
    ComposedChart,
    ResponsiveContainer,

} from "recharts";





const Parkingdata = () => {
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  const progressRef = useRef(null); 
  const [weekday, setWeekday] = useState(["Weekday"]);
  const [selectedDate, setselectedDate] = useState("");
//   const [srcUrl, setsrcUrl] = useState("https://d1s4th28aykoif.cloudfront.net/24hourVideo.mp4");
  const [srcUrl, setsrcUrl] = useState("https://d1s4th28aykoif.cloudfront.net/26_02_2024.mp4");
  const [floor1, setfloor1] = useState("10");
  const [floor2, setfloor2] = useState("20");
  const [floor3, setfloor3] = useState("34");
  const [SliderValue, setSliderValue] = useState("20");
  const [parkingdata, setParkingData] = useState("34");
  const [color, setColor] = useState([]);
  const [nerge, setNerge] = useState([null]);
  const arryDatass = [];
  const [myData, setmyData] = useState([]);
  const [myDatas, setmyDatas] = useState([
    {
        "meter": "179073",
        "code": "PD",
        "name": "250 ASSAY ST"
    }
]);
  

//   const { RangePicker } = DatePicker;

const hourly_data = {
    "data": {
      "hourly_avg": {
        "option_one": [
          [
            {
              "avg": 6.86,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "12AM"
            }
          ],
          [
            {
              "avg": 7.04,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "1AM"
            }
          ],
          [
            {
              "avg": 3.74,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "2AM"
            }
          ],
          [
            {
              "avg": 5.6,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "3AM"
            }
          ],
          [
            {
              "avg": 3.86,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "4AM"
            }
          ],
          [
            {
              "avg": 5.46,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "5AM"
            }
          ],
          [
            {
              "avg": 28.94,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "6AM"
            }
          ],
          [
            {
              "avg": 42.46,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "7AM"
            }
          ],
          [
            {
              "avg": 78.18,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "8AM"
            }
          ],
          [
            {
              "avg": 118.08,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "9AM"
            }
          ],
          [
            {
              "avg": 185.65,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "10AM"
            }
          ],
          [
            {
              "avg": 148.62,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "11AM"
            }
          ],
          [
            {
              "avg": 133.88,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "12PM"
            }
          ],
          [
            {
              "avg": 141.48,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "1PM"
            }
          ],
          [
            {
              "avg": 116.17,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "2PM"
            }
          ],
          [
            {
              "avg": 82.12,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "3PM"
            }
          ],
          [
            {
              "avg": 85.22,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "4PM"
            }
          ],
          [
            {
              "avg": 100.12,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "5PM"
            }
          ],
          [
            {
              "avg": 105.88,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "6PM"
            }
          ],
          [
            {
              "avg": 162.85,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "7PM"
            }
          ],
          [
            {
              "avg": 176.8,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "8PM"
            }
          ],
          [
            {
              "avg": 215.08,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "9PM"
            }
          ],
          [
            {
              "avg": 61.08,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "10PM"
            }
          ],
          [
            {
              "avg": 26.92,
              "meter_id": "179073",
              "meter_unique_name": "179073-",
              "name": "11PM"
            }
          ]
        ],
        "option_two": []
      },
      "status": true
    }
  }
  

const radioChanges = event => {
    setWeekday(event.target.id);
};
 const onMouseClick = event => {
  setWeekday(event.target.id);
};

const onChangeDate = (date, dateString) => {
    console.log("sachin")
    console.log(date,'----------', dateString);
    const videoUrl = "https://d1s4th28aykoif.cloudfront.net/" +dateString +".mp4"
    // const temp = "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"  # '2024-03-14'
    const temp = "https://d1s4th28aykoif.cloudfront.net/27_02_2024.mp4";  
    setsrcUrl(temp)
    console.log('videoUrl',temp)
    setselectedDate(dateString)
  };



  useEffect(() => {
        var user = JSON.parse(localStorage.getItem("MCData"));
        var userid = user?.userid;
        get(`apis/user_color?user_id=${userid}`)
            .then(response => {

                console.log(response.data.color);
                setColor(response.data.color);

            });
            
            hourly_data.data.hourly_avg.option_one.map((item) => {
                let name = item[0].name;
                // console.log(name);
                const meterData = Object.fromEntries(
                    item?.map(({ avg, meter_id }) => [meter_id, avg]),
                );

                const weeklyMeterData = { name, ...meterData };
                console.log()

                arryDatass.push(weeklyMeterData);
            });
            
            setNerge(arryDatass);
            console.log("new hourly_avg +4 4-- ",nerge)
    }, []);


  
  useEffect(() => {
    // Initialize Video.js player
    playerRef.current = videojs(videoRef.current, {
      // Video.js options
      controls: true,
      autoplay: true,
      preload: 'auto',
    });

    // Add event listener for timeupdate to update the progress bar
    playerRef.current.on('timeupdate', () => {
      if (progressRef.current) {
        const currentTime = playerRef.current.currentTime();
        const duration = playerRef.current.duration();
        const percentage = (currentTime / duration) * 100;
        progressRef.current.style.width = `${percentage}%`;
      }
    });

    // Clean up on unmount
    return () => {
      if (playerRef.current) {
        playerRef.current.dispose();
      }
    };
    
  }, []);



  useEffect(() => {
    if (playerRef.current) {
      // Pause the current video playback (if it's playing)
      playerRef.current.pause();
      // Load the new video specified by srcUrl
      playerRef.current.src({ type: 'video/mp4', src: srcUrl });
      // Check if autoplay is allowed (user interaction occurred)
      const isAutoplayAllowed = document.documentElement.dataset.autoplay === 'true';
      if (isAutoplayAllowed) {
        // Play the new video
        playerRef.current.play();
      } else {
        // Handle autoplay restriction (e.g., show play button and wait for user interaction)
      }
    }
  }, [srcUrl]);




  const handlePlayButtonClick = () => {
    if (playerRef.current) {
      if (playerRef.current.paused()) {
        playerRef.current.play();
      } else {
        playerRef.current.pause();
      }
    }
  };

  return (
    <>
    {/* <head>
      <title>{window.location.href.indexOf("mizuwatch.com") > -1 ? "MizuWatch" : "MizuSmart"}  </title></head> */}
      <Header />
    <Main>
    <div className="waterDetails">
      <div className="d-flex justify-content-between mb-4">
          <div className="d-flex fs-30 gap-3">
          {/* <ArrowLeftOutlined onClick={onRedirection} /> */}
          <img src={back} alt="" style={{width:'10px', cursor: 'pointer'}}   />
          <h3 className="mb-0">Parking</h3>
          </div>

          
          <div className="selectCalender py-2 videoDate">
          <select name="All meters" id="selector" className="box custom-select" onChange={onMouseClick}>
                      <option value="week" >Week</option>
                      <option value="month" >Month </option>
                      <option value="year" selected >Year</option>
                      <option value="Last Week">Last 7 Days</option>
                      <option value="Last Month" >Last 30 Days </option>
                      <option value="Last Year">Last 365 Days</option>
                    </select>
                    </div>


          <div className="selectCalender py-2 videoDate">
          <DatePicker onChange={onChangeDate}  separator={<SwapOutlined />} /> 
          </div>
      </div>
        </div>
        <div className="bottom-layout">
    <div className="d-flex justify-content-center">
      <div className="videoplay">
      <video ref={videoRef} className="video-js"  >
        <source src={srcUrl} type="video/mp4" />
      </video>
      </div>
      {/* <button  type="primary" size="small" style={{  width: 90, }} onClick={handlePlayButtonClick}>
        Play
      </button> */}
    </div>

    <div className="d-flex align-items-center mt-5" style={{borderRadius: '16px;'}}>
          <div className="days-waters" style={{width: '20px', paddingLeft: '5%'}} >
            <div class="form-check d-flex mb-2 align-items-center">
                <Input className="form-check-input" type="radio" id="Weekday" name="day" onChange={radioChanges} defaultChecked={true} />
                <label className="form-check-label" for="day1">
                    Weekdays
                </label>
            </div>
            <div className="form-check mb-2 d-flex align-items-center">
                <Input className="form-check-input" type="radio" id="Weekend" name="day" onChange={radioChanges} />
                <label className="form-check-label" for="day2">
                    Weekends
                </label>
            </div>
            <div className="form-check mb-2 d-flex align-items-center">
                <Input className="form-check-input" type="radio" id="Sundays" name="day" onChange={radioChanges} />
                <label className="form-check-label" for="day3">
                    Sunday
                </label>
            </div>
            <div className="form-check mb-2 d-flex align-items-center">
                <Input className="form-check-input" type="radio" id="Mondays" name="day" onChange={radioChanges} />
                <label className="form-check-label" for="day4">
                    Monday
                </label>
            </div>
            <div className="form-check mb-2 d-flex align-items-center">
                <Input className="form-check-input" type="radio" id="Tuesdays" name="day" onChange={radioChanges} />
                <label className="form-check-label" for="day5">
                    Tuesday
                </label>
            </div>
            <div className="form-check mb-2 d-flex align-items-center">
                <Input className="form-check-input" type="radio" id="Wednesdays" name="day" onChange={radioChanges} />
                <label className="form-check-label" for="day6">
                    Wednesday
                </label>
            </div>
            <div className="form-check mb-2 d-flex align-items-center">
                <Input className="form-check-input" type="radio" id="Thursdays" name="day" onChange={radioChanges} />
                <label className="form-check-label" for="day7">
                    Thursday
                </label>
            </div>
            <div className="form-check mb-2 d-flex align-items-center">
                <Input className="form-check-input" type="radio" id="Fridays" name="day" onChange={radioChanges} />
                <label className="form-check-label" for="day8">
                    Fridays
                </label>
            </div>
            <div className="form-check mb-2 d-flex align-items-center">
                <Input className="form-check-input" type="radio" id="Saturdays" name="day" onChange={radioChanges} />
                <label className="form-check-label" for="day9">
                    Saturday
                </label>
            </div>
        </div>

        

        <br/><br/>

        <div style={{ maxWidth: "100%", margin: "0 auto", minHeight: "350px" }} className="legend-wrapper position-relative scroll-show" >
        <br/><br/> 
        <h3>Hourly Average </h3>
        <br/><br/> 
<ResponsiveContainer><>
    <LineChart
        data={nerge}
        width={1350}
        height={300}
        margin={{
            top: 5,
            right: 10,
            left: 20,
            bottom: 1,
        }}
    >

        <XAxis dataKey="name" interval={0} angle={30} dx={20} />
        <YAxis />

        <div className="px-5 d-flex flex-wrap justify-content-start align-items-center mb-5 ">
            {myDatas?.map((item, index) => (
                <>
                    <div className="d-flex me-1 mb-2">
                        <div style={{ width: 10, height: 10, backgroundColor: color[index], marginRight: 6 }}></div>
                        <span className="meter-content"><font color={color[index]}>{item.meter}-{item.name}[{item.code}]</font></span></div>
                </>
            ))}
        </div>
        {myDatas?.map((item, index) => (

            <Line type="monotone"
                dataKey={item.meter}
                isAnimationActive={false}
                name={item?.meter}
                fill={color[index]}
                stroke={color[index]}
                strokeWidth={2}
            >
            </Line>
        )
        )}
        <CartesianGrid stroke="lightGrey" />
        <Tooltip />
    </LineChart>

    <div className='labelYAxis2'>Gallons </div>
    <div className="px-2 d-flex flex-wrap justify-content-start align-items-center mb-5 ">
        {myDatas?.map((item, index) => (
            <>
                <div className="d-flex me-1 mb-2">
                    <div style={{ width: 10, height: 10, backgroundColor: color[index], marginRight: 6 }}></div>
                    <span className="meter-contents"><font color={color[index]}>{item.meter}-{item.name}[{item.code}]</font></span></div>
            </>
        ))}
    </div>
</>
</ResponsiveContainer></div>



    </div>
    </div>
    </Main>
    </>
  );
};

export default Parkingdata;
